export default "__VITE_ASSET__ew5cyYdU__"